import { format, getTime, formatDistanceToNow, startOfWeek, endOfWeek, isWithinInterval } from 'date-fns';

// ----------------------------------------------------------------------

function getOrdinal(day) {
  if (day > 3 && day < 21) return 'th'; // Catch teens
  switch (day % 10) {
    case 1:
      return 'st';
    case 2:
      return 'nd';
    case 3:
      return 'rd';
    default:
      return 'th';
  }
}

export function standardDateFormat(date) {
  return format(new Date(date), 'dd-MM-yyyy');
}

export function fDate(date) {
  const today = new Date();
  const inputDate = new Date(date);
  today.setHours(0, 0, 0, 0);
  inputDate.setHours(0, 0, 0, 0);
  const diffTime = inputDate.getTime() - today.getTime();
  const diffDays = diffTime / (1000 * 60 * 60 * 24);
  switch (diffDays) {
    case -1:
      return 'Yesterday';
    case 0:
      return 'Today';
    case 1:
      return 'Tomorrow';
    default:
      return format(new Date(date), 'dd MMMM yyyy');
  }
}

export function fDateTime(date) {
  return format(new Date(date), 'dd MMM yyyy HH:mm');
}

export function fTimestamp(date) {
  return getTime(new Date(date));
}

export function fDateTimeSuffix(date) {
  return format(new Date(date), 'dd/MM/yyyy hh:mm p');
}

export function fDateForPersistence(date) {
  return format(new Date(date), 'yyyy/MM/dd');
}

export function fDateCompact(date) {
  return format(new Date(date), 'yyyyMMdd');
}
export function fToNow(date) {
  return formatDistanceToNow(new Date(date), {
    addSuffix: true,
  });
}

export function dateMonthWithOrdinal(date) {
  const day = format(date, 'd'); // Get the day of the month
  const ordinalSuffix = getOrdinal(parseInt(day));
  return format(date, `d'${ordinalSuffix}' MMM`);
}

// check whether a given date is within this [current] week
export function dateIsWithinThisWeek(date) {
  const now = new Date(); // todays date
  const startOfTheWeek = startOfWeek(now); // get start of week based on todays date
  const endOfTheWeek = endOfWeek(now); // get start of week based on todays date

  const dateCheck = isWithinInterval(new Date(date), {
    start: new Date(startOfTheWeek),
    end: new Date(endOfTheWeek),
  });
  return dateCheck;
}
